import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';

import classNames from "classnames";

import Spinner from "../spinner/spinner";

import styles from "./styles.module.scss";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  isLoading?: boolean;
  iconBefore?: ReactNode;
  variant?: 'default' | 'text';
  bgColor?: string; // New prop for background color
  removePadding?: boolean;
}

const Button: FC<ButtonProps> = ({
  text,
  className,
  isLoading,
  iconBefore,
  disabled,
  bgColor,
  variant,
  removePadding,
  style,
  ...rest
}) => {
  const buttonStyle = {
    backgroundColor: bgColor || "var(--color-primary)",
    ...style,
  };

  const noPaddingStyle = {
    paddingInline: 0,
    paddingBlock: 0,
  };

  if (variant === "text") {
    return (
      <button
        {...rest}
        className={classNames(styles.textButton, className)}
        disabled={disabled}
        type="button"
        style={removePadding ? noPaddingStyle : style}
      >
        {iconBefore}
        {isLoading ? <Spinner /> : text}
      </button>
    );
  }

  return (
    <button
      {...rest}
      className={classNames(styles.button, className)}
      style={buttonStyle}
      disabled={disabled}
    >
      {iconBefore}
      {isLoading ? <Spinner /> : text}
    </button>
  );
};
export default Button;
